// Copyright (c) 2026 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { useQueryWithOffset } from '@hooks/other/useQueryWithOffset';
import { UseQueryResult } from '@tanstack/react-query';
import { TransferInstruction } from '@daml.js/splice-api-token-transfer-instruction/lib/Splice/Api/Token/TransferInstructionV1';
import { useLedgerApiClient } from '../../../../contexts/LedgerApiContext';
import InterfaceContract from '../../../../utils/InterfaceContract';

// useTransferInstructions.ts

export const useTransferInstructions = <T = InterfaceContract<TransferInstruction>[]>(
  // We add an optional select parameter
  select?: (data: InterfaceContract<TransferInstruction>[]) => T,
): UseQueryResult<T, string> => {
  const ledgerApi = useLedgerApiClient();

  return useQueryWithOffset({
    queryKey: ['queryTransferInstructions'],
    queryFn: async (_, offset) => {
      return ledgerApi.queryTransferInstructions(offset);
    },
    select,
  });
};
